import axios from "axios";
import { authenticatedApiConfig, generateURL } from "./BaseApiService";
export class AIPartnerService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async getAvailablePartners() {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/ai-partners/available"), await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
}
